import { useCallback, useEffect, useState } from 'react'
import { Skeleton } from '@mui/material'
import { useFormikContext } from 'formik'

import { IScanCreateForm } from 'src/types'

import { AccessErrorText } from './access-error-text.component'
import { ScanMap } from './map.component'
import { MapWrapper } from './wrapper.component'
import { COORDS_MULTIPLIER } from 'src/constants'

export const ScannerDetailsMap = () => {
  const { setFieldValue, values } = useFormikContext<IScanCreateForm>()
  const [locationLoading, setLocationLoading] = useState(true)

  const handleAccessLocation = useCallback(() => {
    if (values.scanner_latitude && values.scanner_longitude) return setLocationLoading(false)
    navigator.geolocation.getCurrentPosition(successCallback, errorCallback)

    function successCallback(position: GeolocationPosition) {
      setLocationLoading(false)
      setFieldValue('scanner_latitude', Math.round(position.coords.latitude * COORDS_MULTIPLIER))
      setFieldValue('scanner_longitude', Math.round(position.coords.longitude * COORDS_MULTIPLIER))
    }

    function errorCallback() {
      setLocationLoading(false)
    }
  }, [setFieldValue, values.scanner_latitude, values.scanner_longitude])

  useEffect(() => {
    handleAccessLocation()
  }, [handleAccessLocation])

  if (locationLoading) {
    return (
      <MapWrapper>
        <Skeleton width="100%" height={240} variant="rounded" />
      </MapWrapper>
    )
  }

  if (!(values.scanner_latitude && values.scanner_longitude)) {
    return (
      <MapWrapper>
        <AccessErrorText handleAccessLocation={handleAccessLocation} />
      </MapWrapper>
    )
  }

  return (
    <MapWrapper>
      <ScanMap
        center={{
          lat: values.scanner_latitude / COORDS_MULTIPLIER,
          lng: values.scanner_longitude / COORDS_MULTIPLIER,
        }}
      />
    </MapWrapper>
  )
}
